import React from "react";
import { Tabs, TabsList, TabsTrigger } from "../../../ui/Tabs";
import type { Granularity } from "../types";

interface GranularityToggleProps {
  value: Granularity;
  onChange: (granularity: Granularity) => void;
}

/**
 * Daily | weekly window toggle (design doc 015 §6). Changes only the
 * aggregation window over the same per-failure assignments — there is no
 * separate clustering per granularity.
 */
export function GranularityToggle({ value, onChange }: GranularityToggleProps) {
  return (
    <Tabs value={value} onValueChange={(v) => onChange(v as Granularity)}>
      <TabsList>
        <TabsTrigger value="weekly">Weekly</TabsTrigger>
        <TabsTrigger value="daily">Daily</TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
